<template>
  <div class="basket-article -header" :class="{ '-plan-c': planModel === 'c' }">
    <div class="basket-article__description">
      <HeaderLabel :text="$t('sl.basket.headers.model_'+planModel+'.description')" />
    </div>

    <div class="basket-article__quantity">
      <slot name="quantity">
        <HeaderLabel v-if="planModel === 'c' && basket.isGenerated" :text="$t('sl.basket.headers.model_c.orderQuantity')" />
        <HeaderLabel v-else-if="planModel === 'b'" :text="$t('sl.basket.headers.model_b.quantity')" />
      </slot>
    </div>

    <div class="basket-article__input" v-if="planModel !== 'b'">
      <slot name="input">
        <HeaderLabel :text="$t('sl.basket.headers.model_'+planModel+'.adjustOrder')" />
      </slot>
    </div>

    <div class="basket-article__unit" v-if="planModel !== 'b'">
      <HeaderLabel :text="$t('sl.basket.headers.model_'+planModel+'.packageUnit')" />
    </div>

    <div class="basket-article__total">
      <HeaderLabel :text="$t('sl.basket.headers.model_'+planModel+'.price')" add-classes="text-right" />
    </div>
  </div>
</template>
<script>
import HeaderLabel from '../../Design/HeaderLabel.vue'
import {mapGetters} from "vuex";

export default {
  name: 'OrderBasketHeader',
  components: {HeaderLabel},

  computed: {
    ...mapGetters({
      basket: 'smartLogisticBasket/basket',
    }),
    planModel() {
      return this.$store.getters['smartLogisticSettings/planModel']
    },
  }

}
</script>

<style>

</style>
